import _cloneDeep from "lodash/cloneDeep";
import {
    CHANGE_DIRECTORIES_CHECKBOX,
    ERROR_MESSAGE, LOADER_DIRECTORIES, OPEN_ALERT_SUCCESS,
    OPEN_MODAL,
    SET_INDEX_ISSUINGAUTHORITY,
    SET_INDEX_SOATO,
    SET_INDEX_TERRORIST,
    SET_ISSUING_AUTHORITY_DIRECTORIES,
    SET_SOATO_DIRECTORIES,
    SET_TERRORIST_DIRECTORIES,
} from "../actions/actionTypes";

const initialState = {
    terroristDirectory: null,
    soatoDirectory: null,
    issuingAuthorityDirectory: null,
    terroristIndex: null,
    soatoIndex: null,
    issuingAuthority: null,
    isModal: false,
    errorMessage: null,
    terroristCheckbox: false,
    soatoCheckbox: false,
    issuingAuthorityCheckbox: false,
    isLoading: false,
    isAlert: false
}

const directoriesReducer = (state = _cloneDeep(initialState), action) => {
    switch (action.type) {
        case SET_INDEX_TERRORIST:
            return {
                ...state,
                terroristIndex: action.payload.countOfRecords,
                terroristCheckbox: false,
                isAlert: true,
                errorMessage: null
            }
        case SET_INDEX_SOATO:
            return {
                ...state,
                soatoIndex: action.payload.countOfRecords,
                soatoCheckbox: false,
                isAlert: true,
                errorMessage: null
            }
        case SET_INDEX_ISSUINGAUTHORITY:
            return {
                ...state,
                issuingAuthority: action.payload.countOfRecords,
                issuingAuthorityCheckbox: false,
                isAlert: true,
                errorMessage: null
            }
        case OPEN_MODAL:
            return {
                ...state,
                isModal: action.payload.isOpen,
                isLoading: action.payload.isLoading
            }
        case ERROR_MESSAGE:
            return {
                ...state,
                errorMessage: action.payload,
                isModal: false
            }
        case CHANGE_DIRECTORIES_CHECKBOX:
            return {
                ...state,
                [action.payload]: !state[action.payload],
                errorMessage: null
            }
        case SET_TERRORIST_DIRECTORIES:
            return {
                ...state,
                terroristDirectory: action.payload,
                errorMessage: null
            }
        case SET_SOATO_DIRECTORIES:
            return {
                ...state,
                soatoDirectory: action.payload,
                errorMessage: null
            }
        case SET_ISSUING_AUTHORITY_DIRECTORIES:
            return {
                ...state,
                issuingAuthorityDirectory: action.payload,
                errorMessage: null
            }
        case LOADER_DIRECTORIES:
            return {
                ...state,
                isLoading: action.payload,
            }
        case OPEN_ALERT_SUCCESS:
            return {
                ...state,
                isAlert: false
            }
        default:
            return state
    }
}

export default directoriesReducer
